<template>
  <div class="container">
    <ToastPrime />
    <div class="table-display2">
     <div class="cell-display div2">
       <div class="card">
         <div class="formgrid grid">
             <div class="field col-12 md:col-2 text-left">
                <label for="shipName">{{ $t("shipName") }}</label>
                <p
                  id="shipName"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                ><strong>{{ ship.name }}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
                <label for="shipIMO">{{ $t("imoNumber") }}</label>
                <p
                  id="shipIMO"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                ><strong>{{ ship.imo }}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
                <label for="shipType">{{ $t("shipType") }}</label>
                <p
                  id="shipType"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                ><strong>{{ ship.shipType.name }}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
                <label for="shipGT">{{ $t("grossTonnage") }} - <strong>GT</strong> (t)</label>
                <p
                  id="shipGT"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                ><strong>{{ ship.gt}}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
                <label for="shipDWT">{{ $t("capacityDeadWeight") }} - <strong>DWT</strong> (t)</label>
                <p
                  id="shipDWT"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                ><strong>{{ ship.dwt }}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
             <label for="shipTotalDistance">{{ $t("totalDistance") }} (mn)</label>
                <p
                  id="shipTotalDistance"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                ><strong>{{ ship.totalDistance}}</strong></p>
             </div>
         </div>
 
         <!-- Tabla con combustibles -->
         <div class="formgrid grid">
           <div class="field col-12 md:col-12 p-2"></div>
           <div class="field col-12 md:col-4">
             <FuelConsumptionTable :fuelArray = "fuelConsumptionArray"></FuelConsumptionTable>
           </div>
         </div>
 
         <div class="field col-12 md:col-12 p-2"></div>
         <div class="input-box">
          <div style="display: flex;justify-content: space-around">
             <!--Primera columna-->
             <div style="text-align: left; padding-right: 20px">
                <p for="state">{{ $t("modifType") }}:</p>
                <DropdownPrime
                   id="state"
                   v-model="modifTypeSelected"
                   :options="modifTypes"
                   optionLabel="name"
                   class="field col-12 md:col-12"
                />
                
                <div style="padding-top: 0px;">
                  <label for="modifName">{{ $t("modifName") }}:</label>
                  <input
                  v-model="modification.name"
                  type="text"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
                </div>
                
                <div style="padding-top: 20px;">
                  <label for="modifDescription">{{ $t("modifDescription") }}:</label>
                  <input
                  v-model="modification.description"
                  type="text"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
                </div>
              </div>
                
             <!--Segunda columna  class="field col-6 md:col-2 p-2 text-left"-->
             <div style="text-align: left;">
                <div v-if="modifTypeSelected.name != 'Cambio de combustible'">
                  <p for="state">{{ $t("modifSelecction") }}:</p>
                  <DropdownPrime
                    id="state"
                    v-model="modifFuelReduction"
                    :options="shipFuels"
                    optionLabel="name"
                    class="field col-12 md:col-12"
                  />
                </div>

               <div v-if="modifTypeSelected.name != 'Cambio de combustible'">
                <label for="reductionPercentaje">{{ $t("reductionPercentage") }} <strong>(%)</strong>:</label>
                <input
                   v-model="reductionPercentaje"
                   type="number"
                   class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                />
               </div>
             </div>
             <!--Tercera columna (tabla); vamos a hacer la tabla directamente aquí para evitarnos problemas-->
             <div class="field col-2 md:col-5 text-left">
               <table class="styled-table">
                 <thead>
                   <tr>
                     <th scope="col">{{ $t("fuelType") }}</th>
                     <th scope="col">{{ $t("fuelConsumption") }}<strong>(t)</strong></th>
                   </tr>
                 </thead>
                 <tbody> 
                   <tr v-for="(fuel, index) in this.newFuelConsumptionArray" :key="index">
                     <td v-if="modifTypeSelected.name != 'Cambio de combustible'">
                      {{ fuel.fuel.name }}
                     </td>
                     <td v-if="modifTypeSelected.name === 'Cambio de combustible'">
                       <DropdownPrime
                         id="state"
                         v-model="fuel.fuel"
                         :options="fuelTypes"
                         optionLabel="name"
                         class="input-style"
                       />
                     </td>
                     <td>
                       <input class="input-style" v-model="fuel.consumption" type="number" />
                     </td>
                   </tr>
                 </tbody>
               </table>
             </div>
          </div>
 
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <!--Los avisos y el botón de recalcular-->
          <div style="display: flex;">
           <!--Los avisos -->
           <div class="field col-2 md:col-5 text-left output-box">
             <p>
               <strong>{{ $t("modifWarning") }}: </strong>{{ $t("modifWarning_msg1") }}
             </p>
             <p>
               <strong>{{ $t("modifWarning") }}: </strong>{{ $t("modifWarning_msg2") }}
             </p>
           </div>
 
           <div style="padding-left: 45%;">
             <ButtonPrime @click="recalcular()" id="add-button" class="button">{{ $t("btnRecalculate") }}</ButtonPrime>
           </div>
 
          </div>
         </div>
 
         <div class="field col-12 md:col-12 p-2"></div>
         <div class="field col-12 md:col-12 p-2"></div>
 
         <div style="display: flex;">
           <p for="yearOptions" style="padding-top: 20px; padding-right: 10px;"><strong>{{ $t("year") }}:</strong></p>
           <DropdownPrime
             id="yearOptions"
             v-model="yearSelected"
             :options="allYears"
             class="field col-1 md:col-1"
           />
         </div>
         <div class="output-box">
           <div style="display: flex; justify-content: space-around;">
             <div v-for="(item, index) in filteredCIIVariables" :key="index">
               <div style="text-align: left;">
                 <label for="cii">CII (gCO <sub>2</sub> / t*mn):</label>
                 <div style="display: flex;">
                   <p
                   id="cii"
                   class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                   ><strong>{{ item.value }}</strong></p>
                   <p
                     id="ciiLetter"
                     class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"
                   ><strong>{{ item.letter }}</strong></p>
                 </div>
               </div>
             </div>
             <div v-for="(item, index) in filteredETSVariables" :key="index">
               <div style="text-align: left;">
                 <label for="ets"> {{ $t("label_ETS") }}:</label>
                 <p
                   id="ets"
                   class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                 ><strong>{{ item.costEUA }}</strong></p>
               </div>
             </div>
             <div v-for="(item, index) in filteredFuelEUVariables" :key="index">
               <div style="text-align: left;">
                 <label for="fuelEU"> {{ $t("label_FuelEU") }}:</label>
                 <p
                   id="fuelEU"
                   class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                 ><strong>{{ item.fuelEUPenalty }}</strong></p>
               </div>
             </div>
           </div>
         </div>
 
         <div class="field col-12 md:col-12 p-2"></div>
         <div class="field col-12 md:col-12 p-2"></div>
 
         <div style="padding-left: 70%;">
           <ButtonPrime @click="save()" id="add-button" class="button">{{ $t("save") }}</ButtonPrime>
           &ensp; &ensp; &ensp; &ensp;
           <ButtonPrime @click="cancel()" id="add-button" class="button">{{ $t("cancel") }}</ButtonPrime>
         </div>
 
         <div class="field col-12 md:col-12 p-2"></div>
         <div class="field col-12 md:col-12 p-2"></div>
         <div class="field col-12 md:col-12 p-2"></div>
         <div class="field col-12 md:col-12 p-2"></div>
         <div class="field col-12 md:col-12 p-2"></div>
         <div class="field col-12 md:col-12 p-2"></div>
       </div>
     </div>
    </div>
  </div>
 
 </template>
 
 <script>
 import router from "@/router/index";
 import store from "@/store/index";
 import utils from "@/utils/configuration/config.js";
 import FuelConsumptionTable from "./FuelConsumptionTable.vue";
 import FuelTypeService from "@/services/FuelTypeService";
 import ShipService from "@/services/ShipService";
 import ModificationService from "@/services/Neobuq/ModificationService";
 import ParametricTableService from "@/services/ParametricTableService";
 import NeobuqCarbonService from "@/services/Neobuq/NeobuqCarbonService";
 import ETSService from "@/services/Neobuq/ETSService";
 import FuelEUService from "@/services/Neobuq/FuelEUService";
 import { ToastSeverity } from "primevue/api";
 
 export default{
   components:{
    FuelConsumptionTable,
   },
 
   data(){
    return{
     ship: store.getters.currentShip,
     fuelConsumptionArray : store.getters.currentShip.fuelConsumption,
     modification: store.getters.currentModification,
 
     allYears: ["2023","2024","2025","2026","2027","2028","2029","2030","2031","2032","2033","2034","2035","2036","2037","2038",
     "2039", "2040"],
     yearSelected: "2023",
 
     newFuelConsumptionArray : [],
     modifTypes: [],
     modifTypeSelected: { id: "", name: "" },
     modifFuelReduction: { name: "" },
     reductionPercentaje : 0,
     fuelTypes: [],
     shipFuels: [],
 
     //tenemos 3 arrays diferentes para las variables CII, ETS y FuelEU; que luego guardaremos en la modificación específica
     listCIIValues: [],
     listETSValues: [],
     listFuelEUValues: [],
    }
   },
 
   created(){
     this.shipService = ShipService.getInstance();
     this.carbonService = NeobuqCarbonService.getInstance();
     this.etsService = ETSService.getInstance();
     this.fuelEUService = FuelEUService.getInstance();
    // this.modificationService = ModificationService.getInstance()
     this.parametricTables = ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion)
     this.modifTypes = this.parametricTables["modificationType"]
     //obtenemos los tipos de combustible
     this.fuelTypeService = FuelTypeService.getInstance()
     this.fuelTypeService.getTypes(this.fuelTypes)
 
     //creamos un nuevo array de combustibles para la modificación
     for(let i=0; i < this.fuelConsumptionArray.length; i++){
       var aux = {fuel : this.fuelConsumptionArray[i].fuel, consumption : this.fuelConsumptionArray[i].consumption}
       this.newFuelConsumptionArray.push(aux)
     }
 
     //rellenamos los arrays nuevos con las variables CII, ETS y FuelEU, distintos para cada año
     for(let i=0; i < this.allYears.length; i++){
       this.listCIIValues.push({year : this.allYears[i], value: 0, letter: "", color: ""})
       this.listETSValues.push({year: this.allYears[i], anualEmissions: 0, emissionRights: 0, costEUA: 0})
       this.listFuelEUValues.push({year: this.allYears[i], fuelEUPenalty: 0, complianceBalance : 0})
     }
 
     //si tenemos datos almacenados de antes, los mostramos en la pantalla
     if(this.modification.listCII.length != 0){
       this.listCIIValues = this.modification.listCII
     }
     if(this.modification.listFuelEU.length != 0){
       this.listFuelEUValues = this.modification.listFuelEU
     }
     if(this.modification.listETS.length != 0){
       this.listETSValues = this.modification.listETS
     }
   },
 
   mounted(){
    var valorInicial = this.modification.type 
    //console.log(valorInicial)
    this.$options.watch.modifTypeSelected.handler.call(this, valorInicial, null);
    //console.log("Tipo valorInicial " + typeof(valorInicial))
    this.modifTypeSelected = valorInicial

    this.shipFuels.push({name: "All/Todos"})
    for(let i=0; i<this.fuelConsumptionArray.length; i++){
      //console.log(this.fuelConsumptionArray[i].fuel.name)
      this.shipFuels.push({name: this.fuelConsumptionArray[i].fuel.name})
    }
    console.log(this.modification.fuelSelected)
    this.modifFuelReduction.name = this.modification.fuelSelected
    console.log(this.modifFuelReduction)
    this.$options.watch.modifFuelReduction.handler.call(this)
  },
 
   watch:{
    modifTypeSelected:{
      handler(newVal, oldVal){
        //console.log("Variable antigua: " + oldVal)
 
        this.reductionPercentaje = newVal.percentage
 
        
        if(oldVal === null){
          for(let i=0; i < this.newFuelConsumptionArray.length; i++){
            this.newFuelConsumptionArray[i].fuel = this.fuelConsumptionArray[i].fuel
          }
        }
        //si hemos elegido otra modificación y la anterior fue la del cambio de combustible, tenemos que volver a poner los combustibles antiguos
        else if(oldVal.name === "Cambio de combustible" && newVal.name != "Cambio de combustible"){
 
          for(let i=0; i < this.newFuelConsumptionArray.length; i++){
            this.newFuelConsumptionArray[i].fuel = this.fuelConsumptionArray[i].fuel
          }
          this.recalcular()
        }
 
      },
    },
    modifFuelReduction:{
      handler(){
        this.recalcular()
      }
    }
   },
 
   computed:{
    /*modification() {
       return store.getters.currentModification;
    },*/
    filteredCIIVariables() {
      return this.listCIIValues.filter(item => item.year === this.yearSelected);
    },
    filteredETSVariables() {
      return this.listETSValues.filter(item => item.year === this.yearSelected);
    },
    filteredFuelEUVariables() {
      return this.listFuelEUValues.filter(item => item.year === this.yearSelected);
    },
   },
 
   methods:{
    applyChangesModification(){
      //console.log("2 - Aplicamos cambios")
      this.modification.newFuelConsumption = []
 
      //Reiniciamos el array newFuelCOmsuptionArray y lo igualamos al de base de datos para que no baje cada vez mas el consumo
      this.newFuelConsumptionArray = []
      for(let i=0; i < this.fuelConsumptionArray.length; i++){
        var aux = {fuel : this.fuelConsumptionArray[i].fuel, consumption : this.fuelConsumptionArray[i].consumption}
        this.newFuelConsumptionArray.push(aux)
      }
 
      // console.log("FuelConsumptionArray" + this.fuelConsumptionArray[0].consumption)
      // console.log("newFuelConsumptionArray" + this.newFuelConsumptionArray[0].consumption)
 
      //primero aplicamos el porcentaje de reducción al consumo de combustible
      //esto varía dependiendo del combustible que se haya seleccionado para aplicar la reducción (modifFuelReduction)
      if(this.modifFuelReduction.name == "All/Todos"){
        for(let i=0; i< this.newFuelConsumptionArray.length; i++){
          if(this.reductionPercentaje != 0){
            //aquí interpretamos el 0 como que no hay reducción
            this.newFuelConsumptionArray[i].consumption =  Number((this.newFuelConsumptionArray[i].consumption * ((100-this.reductionPercentaje) / 100)).toFixed(2))
          }
  
          //si la primera vez que calculamos una modificación es "Cambio de combustible", hay que inicializa el array de  this.modification.newFuelConsumption
          if(this.modifTypeSelected.name === "Cambio de combustible"){
            FuelTypeService.AddFuelTypeToModification(this.newFuelConsumptionArray[i].fuel.id, 
                                          this.newFuelConsumptionArray[i].consumption, this.modification)
          }
  
        }
      }else{
        for(let i=0; i < this.fuelConsumptionArray.length; i++){
          if(this.modifFuelReduction.name == this.fuelConsumptionArray[i].fuel.name){
            if(this.reductionPercentaje != 0){
              this.newFuelConsumptionArray[i].consumption = Number((this.newFuelConsumptionArray[i].consumption * ((100-this.reductionPercentaje) / 100)).toFixed(2))
            }
          }
        }
      }
 
      if(this.modifTypeSelected.name != "Cambio de combustible"){
        this.modification.newFuelConsumption = [...this.newFuelConsumptionArray]
      }

      this.modification.personalizedPercentage = this.reductionPercentaje
      this.modification.type = this.modifTypeSelected
      this.modification.fuelSelected = this.modifFuelReduction.name
      //console.log(this.modification.fuelSelected)
      //this.modification.listCII = this.listCIIValues
      //this.modification.listETS = this.listETSValues
      //this.modification.listFuelEU = this.listFuelEUValues
 
      //console.log("this.modification.newFuelConsumption" + this.modification.newFuelConsumption)
    },
 
    recalcular(){
      //console.log("Recalculamos los nuevos valores de la modificación...") 
      //console.log("1 - this.ship.fuelConsumption")
      //console.log(this.ship.fuelConsumption)
      this.applyChangesModification()
     
      const shipData = {...this.ship} //creamos una copia para no interferir con los datos base del buque
 
      //console.log(" 3- this.modification.newFuelConsumption")
      //console.log(this.modification.newFuelConsumption)
 
      //FORMA CORRECTA DE COPIAR UN ARRAY SIN INTERFERIR CON LOS DATOS
      shipData.fuelConsumption = [...this.modification.newFuelConsumption]
 
      //console.log("4 - this.modification")
      //console.log(this.modification)
 
      //shipData.dataForCII NO ESTÁ ACTUALIZADO, hay que cambiar los combustibles y su consumo, por qué están los antiguos (los del buque base)
      //shipData.dataForCII --> arrayFuelVariables --> fuel --> consumption
 
      //crear array nuevo para shipData.dataForCII.arrayFuelVariables
 
      const newArrayFuelVariables = []
      // console.log("5 - shipData.fuelConsumption")
      //console.log(shipData.fuelConsumption)
 
      //primero cogemos los que se usarán para el CII
      for(let i=0; i < shipData.fuelConsumption.length; i++){
        if(shipData.fuelConsumption[i].fuel.for_cii){
          newArrayFuelVariables.push(shipData.fuelConsumption[i])
        }
      }
      //console.log("6 - newArrayFuelVariable")
      //console.log(newArrayFuelVariables)
      //console.log("7 - PRE - shipData.dataForCII.arrayFuelVariables.length")
      //console.log(shipData.dataForCII.arrayFuelVariables) 
 
      //sobreescribimos "shipData.dataForCII.arrayFuelVariables" por el nuevo "newArrayFuelVariables"
      //por ahora, usaremos el mismo array pero SOLO cambiaremos el tipo de combustible, el resto de variables seguirán igual, y si hay otro 
      //combustible que también se pueda usar para el CII (tipo, si antes teníamos 2 y ahora 3) pues el 3 no se usará, porque hay que añadirle
      //los otros valores (a menos que copiemos unos imaginarios de otro de los combustibles que sí existen)
      //POR AHORA SE SALTARÁ 1, YA LO GESTIONO DESPUÉS
 
      for(let i = 0; i < shipData.dataForCII.arrayFuelVariables.length; i++){
        shipData.dataForCII.arrayFuelVariables[i].fuel = {...newArrayFuelVariables[i]}
      }
 
      //console.log("9 - shipData")
      //console.log(shipData) 
 
 
      this.listCIIValues =  this.carbonService.calc_attained_CII(shipData, shipData.dataForCII, shipData.anualPrewrittenCII)
      this.modification.listCII = this.listCIIValues
      //console.log("10 - CII para la modificación:")
      //console.log(this.listCIIValues)
 
      //ETS
      this.listETSValues= this.etsService.calc_ets_values(shipData, this.listETSValues, shipData.dataForETS.priceEUA,  shipData.dataForETS.selectedGWPOPtion)
      this.modification.listETS = this.listETSValues
      //console.log("11 - ETS para la modificación:")
      //console.log(this.listETSValues)
 
      //FuelEU 
 
      this.modification.listFuelEU = []
 
      //BUCLE INFINITO PORQUE SE VA SUMANDO CONSTANTEMENTE
      var arrayAux = [...shipData.baseFuelEU]
      for(let i=0; i < arrayAux.length; i++){
 
        //devolveremos el mismo objeto, pero con los nuevos datos añadidos
        //this.listFuelEUValues[i] = this.fuelEUService.calc_fuelEU_values(arrayAux[i], shipData, shipData.dataForFuelEU.GWPOPtion, i)
        const auxi = this.fuelEUService.calc_fuelEU_values(arrayAux[i], shipData, shipData.dataForFuelEU.GWPOPtion, i)
        //console.log(auxi)
 
        //var aux = {year: this.listFuelEUValues[i].year, value: this.listFuelEUValues[i].fuelEUPenalty}
        this.listFuelEUValues[i] = {year: auxi.year, fuelEUPenalty: auxi.fuelEUPenalty, complianceBalance : auxi.complianceBalance}
        //this.modification.listFuelEU.push(aux)
        //console.log("Este splice??")
       // this.modification.listFuelEU.splice(i, 0, aux)
        this.modification.listFuelEU[i] = {year: this.listFuelEUValues[i].year, fuelEUPenalty: this.listFuelEUValues[i].fuelEUPenalty,
                                            complianceBalance :this.listFuelEUValues[i].complianceBalance}
      }
 
      //let arrayOrdenado = [... this.modification.listFuelEU];
      //arrayOrdenado.sort((a, b) => a.year - b.year);
 
      //console.log("12 - FuelEU para la modificación:")
      //console.log(this.listFuelEUValues)
 
      //console.log("13 - this.modification.listFuelEU")
      //console.log(this.modification.listFuelEU)
 
      //console.log("this.filteredFuelEUVariables")
      //console.log(this.filteredFuelEUVariables)
    },
 
    save(){
      //console.log("Guardamos la modificación...")
      //console.log(this.modification)
      const errors = ModificationService.getInstance().saveModification(
        store.getters.currentShip.id,
        store.getters.currentModification
      );
 
      if (errors != "") {
        this.showToast(false, "Error guardando la modificación: " + errors);
      } else {
        this.showToast(true, "Modificación salvada correctamente");
      }
    },
 
    cancel(){
      //console.log("Cancelamos la modificación...")
      //console.log("FormEditModification-cancel", this.ship);
      this.shipService.selectedShip({});
      router.push({ name: "neobuqHome" });
    },
 
    showToast(successful, message) {
      if (successful) {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: message,
          life: 3000,
        });
      } else {
        this.$toast.add({
          severity: ToastSeverity.ERROR,
          closable: false,
          summary: message,
          life: 3000,
        });
      }
    },
   }
  
 }
 
 </script>
 
 <style scoped>
 .input-box{
   border-style: dotted;
   padding-top: 20px;
   padding-bottom: 20px;
   padding-left: 20px;
 }
 
 .output-box{
   border-style: solid;
   padding-top: 20px;
   padding-bottom: 20px;
   padding-left: 20px;
 }
 
 .button{
   height: 70px;
   border-radius: 20px;
   text-align: center;
 }
 
 /*PARA LA TABLA */
 .styled-table {
   width: 100%;
   border-collapse: collapse;
   border-radius: 8px;
   overflow: hidden;
   box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
   margin: 20px 0;
 }
 
 .styled-table th,
 .styled-table td {
   padding: 16px 15px;
   text-align: left;
   border-bottom: 1px solid #ddd;
 }
 
 .styled-table th {
   background-color: #f2f2f2;
 }
 
 .styled-table tbody tr:last-child td {
   border-bottom: none;
 }
 
 .styled-table tbody tr:hover {
   background-color: #f5f5f5;
 }
 
 .input-style{
   border-radius: 5px;
   height: 40px;
   width: 250px;
 }
 
 
 </style>